import BaseModule from "~/vuex/modules/base-module";
import StringHelper from "~/helpers/StringHelper";
import ObjectHelper from "~/helpers/ObjectHelper";

let Logs = {...BaseModule};

Logs.actions.write = async function({commit, getters}, data) {

        let response = await this.axios.post(
            '/api/logs',
            {
                data: {
                    type: "log",
                    attributes: {
                        message: data.message,
                    }
                }
            }
        );

        if (response.status === 200) {
            return true;
        }

        return false;
};

export default Logs;